let plaidScriptPromise = null;

export const loadPlaidScript = () => {
  if (typeof window === 'undefined') return Promise.resolve(false);
  if (window.Plaid) return Promise.resolve(true);
  if (plaidScriptPromise) return plaidScriptPromise;

  const existing = document.querySelector('script[src="https://cdn.plaid.com/link/v2/stable/link-initialize.js"]');
  if (existing) {
    plaidScriptPromise = new Promise((resolve) => {
      if (window.Plaid) {
        resolve(true);
        return;
      }
      existing.addEventListener('load', () => resolve(true));
      existing.addEventListener('error', () => resolve(false));
    });
    return plaidScriptPromise;
  }

  plaidScriptPromise = new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });

  return plaidScriptPromise;
};
